class ValidationService {
  static IsSingleFileUploadValid(file, privileges) {
    const validImageTypes = ["image/jpeg", "image/png", "image/gif", "image/webp"];
    const validDocTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-powerpoint",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      "text/plain",
    ];

    if (validImageTypes.includes(file.type)) {
      return { isValid: true };
    }

    if (validDocTypes.includes(file.type)) {
      if (!privileges.canUploadVideo) {
        return {
          isValid: false,
          error: `CantUploadDocument`,
        };
      }

      const sizeKB = file.size / 1024;
      if (sizeKB > privileges.maxFileSize) {
        return {
          isValid: false,
          error: `FileTooBig`,
        };
      }
      return { isValid: true };
    }

    return {
      isValid: false,
      error: "UnsupportedFormat",
    };
  }

  static IsFileUploadValid(file, fileType = "images") {
    const imageExtensions = ["jpg", "jpeg", "png", "gif"];
    const videoExtensions = ["mp4", "avi", "mov"];

    if (fileType === "images" && !imageExtensions.includes(file.name.split(".").pop().toLowerCase())) {
      return {
        isValid: false,
        message: "Veuillez sélectionner un fichier image avec une extension valide (jpg, jpeg, png, gif).",
      };
    }

    if (fileType === "videos" && !videoExtensions.includes(file.name.split(".").pop().toLowerCase())) {
      return {
        isValid: false,
        message: "Veuillez sélectionner un fichier vidéo avec une extension valide (mp4, avi, mov).",
      };
    }

    const maxSize = 25 * 1024 * 1024;

    if (file.size > maxSize) {
      return {
        isValid: false,
        message: `Le fichier est trop volumineux. La taille maximale autorisée est de ${maxSize / (1024 * 1024)} Mo.`,
      };
    }
    return { isValid: true, message: "" };
  }
}

export default ValidationService;
